module.exports = __webpack_public_path__ + "img/meeting-bg-cancel.6ef6eced.png";